import { Routes } from '@angular/router';
import { DetailGamesComponent } from './pages/detail-games/detail-games.component';
import { ListGamesComponent } from './pages/list-games/list-games.component';

export const routes: Routes = [
    { path: 'game-options', pathMatch:'full', component: DetailGamesComponent, title: 'Detail du jeu' },
    { path: 'list-games', pathMatch:'full', component: ListGamesComponent, title: 'Liste de jeux'},
    { path: '', redirectTo: '/list-games', pathMatch: 'full'},
];
